export default "<!-- Vue Component -->\n\n<template>\n  <v-data-iterator content-tag=\"v-layout\">\n    ...\n  </v-data-iterator>\n</template>\n";